import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface SimpleDialogData {
  new: boolean;
  name?: string;
  title?: string;
  label?: string;
  cancelText?: string;
  submitText?: string;
  required?: boolean;
}

@Component({
  selector: 'app-simple-dialog',
  standalone: false,
  template: `
    <div mat-dialog-title style="display: flex; align-items: start; gap: 10px; justify-content: space-between; margin-top: 20px;">
      <h2 class="cpo-dialog-title">{{ title }}</h2>
      <close-x (click)="onCancel()"></close-x>
    </div>

    <div mat-dialog-content class="cpo-dialog-content"><app-textbox
      [label]="label"
      [required]="required"
      [showRequired]="required"
      [(ngModel)]="name"
      [readonly]="false"
    ></app-textbox></div>
    <mat-dialog-actions align="end">
      <div style="display: flex; align-items: start; gap: 20px; margin: 20px auto; justify-content: center;">
        <input
          type="button"
          style="cursor: pointer;"
          [value]="cancelText"
          class="cancel"
          (click)="onCancel()"
        />
        <input
          [disabled]="required && !name"
          style="cursor: pointer;"
          type="button"
          [value]="submitText"
          class="primary"
          (click)="onSave()"
        />
      </div>
    </mat-dialog-actions>
  `,
  styles: [`
    .full-width {
      width: 100%;
      min-width: 320px;
    }
  `],
})
export class SimpleDialogComponent {
  name: string;
  title: string;
  cancelText: string;
  submitText: string;
  required: boolean;
  label: string;
  @HostListener('keydown.escape')
  onEscape(): void {
    this.onCancel();
  }

  constructor(
    public dialogRef: MatDialogRef<SimpleDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleDialogData
  ) {
    this.name = data.name ?? '';
    this.title = data.title ?? (data.new ? 'Create Name' : 'Edit Name');
    this.cancelText = data.cancelText ?? 'Cancel';
    this.submitText = data.submitText ?? 'Save';
    this.required = data.required ?? false;
    this.label = data.label ?? 'Name';
    this.dialogRef.disableClose = true;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    this.dialogRef.close(this.name.trim());
  }
}